export function getAccessToken(state) {
  return state.accessToken;
}

export function getUsername(state) {
  return state.username;
}